import { BaseField } from './BaseField';

const imgGardenAreaIcon = "/assets/garden-area-icon.svg";

export class GardenOrPlotField extends BaseField {
  constructor() {
    super({
      key: 'garden_or_plot',
      icon: imgGardenAreaIcon,
      defaultLabel: null
    });
  }

  renderForList(property) {
    const plot = property.specifications.features.plot;
    const garden = property.specifications.features.garden;

    if (plot?.available && (!garden?.available || garden.area === 0)) {
      return { label: 'Pow. działki', value: `${plot.area} m²` };
    }
    if (garden?.available) {
      const value = garden.area === 0 ? 'Nie podano' : `${garden.area} m²`;
      return { label: 'Pow. ogrodu', value };
    }
    return { label: 'Pow. ogrodu', value: 'brak' };
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}
